export default __webpack_public_path__ + "static/media/hand-drawn-different-profile-icons-pack_52683-71390.b205a9f9.jpg";